// Auth DTOs - Data Transfer Objects

export class LoginDto {
  constructor(
    public email: string,
    public password: string
  ) {}
}

export class RegisterDto {
  constructor(
    public email: string,
    public password: string,
    public name: string
  ) {}
}

export class ForgotPasswordDto {
  constructor(public email: string) {}
}

export class ResetPasswordDto {
  constructor(
    public token: string,
    public password: string
  ) {}
}

export class AcceptInviteDto {
  constructor(
    public token: string,
    public password: string
  ) {}
}

export class AuthResponseDto {
  constructor(
    public access_token: string,
    public user: any
  ) {}
}

export class MessageResponseDto {
  constructor(public message: string) {}
}
